'use client';
import {
  TypeModalCarouselFields,
  TypeModalVideoFields,
} from '@/core/generated-types';
import { useCallback, useState } from 'react';
import Image from 'next/image';

import { HeaderText, Video, Modal } from '@/components/ui';
import { HeaderSize } from '@/components/ui/HeaderText';
import { Carousel } from '@/components/common';

import PlayButtonIcon from '@/public/assets/icons/play-button.svg';

interface MediaTextTitleModalInterface {
  fields: TypeModalVideoFields | TypeModalCarouselFields;
}

function MediaTextTitleModal({ fields }: MediaTextTitleModalInterface) {
  const [isOpen, setIsOpen] = useState(false);

  // The carousel and video fields were created as needed in Contentful,
  // so there is no way to have a modal with empty content
  const modalVideo =
    'video' in fields ? (fields as TypeModalVideoFields) : null;
  const modalCarousel =
    'carousel' in fields ? (fields as TypeModalCarouselFields) : null;

  const toggleModal = useCallback(() => {
    setIsOpen((isOpen) => !isOpen);
  }, []);

  return (
    <div className="mt-auto">
      <button
        onClick={toggleModal}
        className="flex items-center gap-2 hover:opacity-80 text-blue-deep text-lg font-bold"
      >
        {modalVideo && <Image src={PlayButtonIcon} alt="Video Play icon" />}
        {fields.openModalCta}
      </button>

      <Modal
        isOpen={isOpen}
        handleClose={toggleModal}
        modalClasses={{
          desktop: {
            minWidth: '37.5rem',
            width: '55%',
            maxWidth: '45%',
          },
          mobile: {
            paddingBottom: '0',
          },
        }}
        contentClasses="-mx-4 md:-mx-0 lg:w-full"
      >
        <HeaderText
          size={HeaderSize.H3}
          text={fields.title}
          align="center"
          classes="mt-6 mb-5"
        />
        {modalCarousel && <Carousel {...modalCarousel.carousel.fields} />}
        {modalVideo && (
          <Video
            classes="h-full object-cover w-full aspect-[1/1]"
            src={modalVideo.video.fields.video?.fields.file.url as string}
            loop={false}
            muted={false}
            autoplay
            controls
          />
        )}
      </Modal>
    </div>
  );
}

export default MediaTextTitleModal;
